const MaterialUiIcon = () => (
    <svg viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 17.454v-17.451l15.113 8.725v5.817l-10.076-5.817v11.634z" />
        <path d="M15.113 8.729l15.113-8.725v17.451l-10.076 5.817-5.038-2.908 10.076-5.817v-5.817l-10.076 5.817z" />
        <path d="M15.113 20.363v5.817l10.076 5.817v-5.817z" />
        <path d="M25.189 31.997l15.113-8.725v-11.634l-5.038 2.908v5.817l-10.076 5.817zM35.264 8.729v-5.817l5.038-2.908v5.817z" />
    </svg>
);

export default MaterialUiIcon;
